import React from 'react'

export function Gastos() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="25.687" height="22.935" viewBox="0 0 25.687 22.935">
  <g transform="translate(-32 -47.981)">
    <path d="M-12.33-16H6.017a3.674,3.674,0,0,1,3.67,3.67V-1.321a3.674,3.674,0,0,1-3.67,3.67H-12.33A3.674,3.674,0,0,1-16-1.321V-12.33A3.674,3.674,0,0,1-12.33-16ZM6.017.513A1.837,1.837,0,0,0,7.853-1.321V-12.33a1.837,1.837,0,0,0-1.834-1.834H-12.33a1.837,1.837,0,0,0-1.834,1.834V-1.321A1.837,1.837,0,0,0-12.33.513Z" transform="translate(48 68.567)" fill="#060606"/>
    <path d="M33.834,57.154H32V54.345a3.787,3.787,0,0,1,3.075-3.719l15.119-2.581a3.784,3.784,0,0,1,4.475,3.719v1.721H52.834V51.765a1.949,1.949,0,0,0-2.315-1.915L35.4,52.43a1.947,1.947,0,0,0-1.568,1.913Z" fill="#060606"/>
    <path d="M337.834,259.67a1.834,1.834,0,1,1,1.834-1.834,1.834,1.834,0,0,1-1.834,1.834Z" transform="translate(-286.569 -196.094)" fill="#707070"/>
  </g>
</svg>

 
  )
}
